<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page
    [breadcrumb]="
      breadcrumb.length
        ? breadcrumb
        : [
            {label: titlePath | translate, path: '/recipients'},
            {label: title | translate}
          ]
    "
    [title]="title | translate"
  >
    <div page-body>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</ng-template>

<ng-template #contentTemplate>
  <div class="gw-flex gw-justify-end gw-mb-6">
    <gatewee-button
      [title]="'features.integrations.configureNewKey' | translate"
      variant="primary"
      iconName="@phi.plus"
      (click)="newIntegration()"
    ></gatewee-button>
  </div>

  <div
    class="gw-rounded-xl gw-shadow-sm gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-overflow-hidden"
  >
    <gatewee-table-v2
      *ngIf="keys && columns.length"
      [data]="keys"
      [columns]="columns"
      [page]="1"
      [pageSize]="10"
      [total]="keys.length"
      [showSettings]="true"
      [tableId]="'integrations-table'"
      (outClick)="onActionClicked($event)"
    ></gatewee-table-v2>
  </div>
</ng-template>

<ng-template #newIntegrationModal let-observer>
  <div
    class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
  >
    <h4
      class="gw-text-xl gw-font-semibold gw-text-text-primary"
      id="modal-basic-title"
    >
      {{ 'features.integrations.newIntegration' | translate }}
    </h4>
  </div>
  <div class="gw-p-6">
    <form [formGroup]="providerForm">
      <div class="gw-mb-6">
        <gatewee-select-v3
          [label]="'features.integrations.provider' | translate"
          [items]="providers"
          [placeholder]="
            'features.integrations.providerPlaceholder' | translate
          "
          formControlName="provider"
        ></gatewee-select-v3>
      </div>
      <div class="gw-flex gw-justify-end gw-gap-3">
        <gatewee-button
          [title]="'common.actions.proceed' | translate"
          variant="primary"
          type="button"
          [disabled]="providerForm.invalid"
          (click)="
            providerForm.valid &&
              open(providerForm.get('provider')?.value ?? '', observer)
          "
        ></gatewee-button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #confirmEditDialog let-observer let-data="data">
  <div class="gw-space-y-4">
    <p class="gw-text-text-primary">
      {{
        'features.integrations.confirmEdit.message'
          | translate : {id: data?.id || id}
      }}
    </p>
    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="primary"
        [title]="'features.integrations.confirmEdit.confirmButton' | translate"
        (click)="observer.next(true); observer.complete()"
      ></gatewee-button>
    </div>
  </div>
</ng-template>
